import cx from "classnames"
import { useMotionValue, useSpring } from "framer-motion"
import { useEffect, useRef, useState } from "react"

export function Counter({ slide, value }) {
  const ref = useRef(null)
  const wrapperRef = useRef(null)
  const motionValue = useMotionValue(0)
  const springValue = useSpring(motionValue)
  const [decimal, setDecimal] = useState(0)

  useEffect(() => {
    if (slide) {
      if (slide.unitAlternative && slide.unitLimit && value > slide.unitLimit) {
        if (slide.unitOperator === "/") {
          setDecimal(1)
          motionValue.set(value / slide.unitLimit)
        }
      } else {
        motionValue.set(Math.floor(value))
      }
    } else {
      motionValue.set(Math.floor(value))
    }
  }, [motionValue, value, slide])

  useEffect(
    () =>
      springValue.onChange((latest) => {
        if (ref.current) {
          ref.current.textContent = new Intl.NumberFormat("sv-SE").format(
            latest.toFixed(decimal)
          )
        }

        if (wrapperRef.current && slide) {
          const length = latest.toFixed(0).length

          if (length > 5) {
            wrapperRef.current.className = "text-2xl md:text-3xl lg:text-4xl"
          } else if (length > 4) {
            wrapperRef.current.className = "text-3xl md:text-4xl lg:text-5xl"
          } else if (length > 3) {
            wrapperRef.current.className = "text-4xl md:text-5xl lg:text-6xl"
          } else {
            wrapperRef.current.className = "text-5xl md:text-6xl lg:text-7.5xl"
          }
        }
      }),
    [springValue, decimal, slide]
  )

  return (
    <span
      ref={wrapperRef}
      className={cx({ "text-5xl md:text-6xl lg:text-7.5xl": slide })}>
      {slide &&
        (slide.unit === "kg" || slide.unit === "liter") &&
        value > 0 && <span>-</span>}
      <span ref={ref}>0</span>
    </span>
  )
}
